//@ts-check
define('TrackingSO.Checkout.View', [
    'Wizard.Module',
    'LiveOrder.Model',
    'Utils',
    'underscore',
    'jQuery',
    'empty.tpl'
], function (
    WizardModule,
    LiveOrderModel,
    Utils,
    _,
    jQuery,
    template
) {
    'use strict';

    return WizardModule.extend({

        template: template,

        campaignData: false,

        initialize: function (options) {
            WizardModule.prototype.initialize.apply(this, arguments);
            this.cart = LiveOrderModel.getInstance();
        },

        submit: function () {
            var self = this;
            var deferred = jQuery.Deferred();
            var expirationTimeMinutes = (this.options.trackingSOConfiguration && this.options.trackingSOConfiguration.expirationTimeMinutes) || 20;
            var EXPIRATION_TIME = expirationTimeMinutes * 60 * 1000; // Convert minutes to milliseconds

            try {
                var parameterName = (this.options.trackingSOConfiguration && this.options.trackingSOConfiguration.parameterName) || 'ad';
                var campaignData = localStorage.getItem(parameterName);

                if (campaignData) {
                    try {
                        var parsedData = JSON.parse(campaignData);
                        var currentTime = Date.now();
                        var storedTime = parsedData.timestamp;

                        if (storedTime && (currentTime - storedTime > EXPIRATION_TIME)) {
                            console.log('TrackingSO: Campaign data expired. Cleaning localStorage.');
                            localStorage.removeItem(parameterName);
                            return deferred.resolve();
                        }

                        if (!parsedData || !parsedData.value) {
                            localStorage.removeItem(parameterName);
                            return deferred.resolve();
                        }
                        campaignData = parsedData.value;
                      
                        var currentOptions = this.cart.get('options') || {};
                        currentOptions.custbody_google_ads_campaign = campaignData;
                        this.cart.set('options', currentOptions);

                        return this.cart.save().then(function () {
                            console.log('TrackingSO: Campaign data saved to live order.');
                            localStorage.removeItem(parameterName);
                            return deferred.resolve();
                        }).catch(function (error) {
                            console.error('TrackingSO: Failed to save campaign data to live order.', error);
                            return deferred.resolve();
                        });
                    } catch (parseError) {
                        console.warn('TrackingSO: Invalid campaign data format. Cleaning localStorage.');
                        localStorage.removeItem(parameterName);
                        return deferred.resolve();
                    }
                }

                return deferred.resolve();

            } catch (error) {
                console.error('TrackingSO Error: ', error);
                return deferred.resolve();
            }
        }
    });
});
